// extracted by mini-css-extract-plugin
export default {"container":"aqoZ2SGW36RuA7c7JntQ","fader":"ENVeL286M2VqFqUYmJl_"};